import { render, staticRenderFns } from "./ModalClose.vue?vue&type=template&id=355fadbe"
import script from "./ModalClose.vue?vue&type=script&lang=js"
export * from "./ModalClose.vue?vue&type=script&lang=js"
import style0 from "./ModalClose.vue?vue&type=style&index=0&id=355fadbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports